export default __webpack_public_path__ + "static/media/music.b6e35b61.mp3";